<script setup lang="ts">
import { CallRecordingDialog } from "~/.nuxt/components";
import { useCallHistoriesStore } from "~/projects/cc/stores/callHistorieStore";

const callHistoriesStore = useCallHistoriesStore();
const handleBeforeClose = () => {
  callHistoriesStore.showAudioModal = false;
  callHistoriesStore.selectedHistoryForEdit = {};
};
</script>
<template>
  <el-dialog
    :key="callHistoriesStore.selectedHistoryForEdit.id"
    v-model="callHistoriesStore.showAudioModal"
    :before-close="handleBeforeClose"
    title="Audio"
    top="0"
  >
    <CallRecordingAudio
      v-if="callHistoriesStore.showAudioModal"
      autoplay
      class="w-full origin-left"
      style="border: 1px solid #5a17b9; border-radius: 50px"
      :call-history="callHistoriesStore.selectedHistoryForEdit"
    />
  </el-dialog>
</template>
